import React from 'react';
import { motion } from 'framer-motion';
import { FileText } from 'lucide-react';

export const PDFPreview = ({ fileURL }) => {
    if (!fileURL) {
        return (
            <div className="h-full flex flex-col items-center justify-center text-slate-400 bg-slate-50 rounded-xl border-2 border-dashed border-slate-200 p-8">
                <FileText className="h-16 w-16 mb-4 opacity-20" />
                <p className="text-sm font-medium">No document selected</p>
            </div>
        );
    }

    return (
        <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            className="h-[calc(100vh-8rem)] bg-slate-800 rounded-xl overflow-hidden shadow-xl"
        >
            <iframe
                src={fileURL}
                className="w-full h-full border-none"
                title="PDF Preview"
            />
        </motion.div>
    );
};
